<template>
  <div class="field-input" :class="{ 'has-error': $validator.errors.has(name, validateScope) }">
    <el-input :type="type" v-model="internalValue" :disabled="disabled === true" :readonly="readonly === true"
              :placeholder="placeholder" :name="name" v-validate="validate" :data-vv-as="validateLabel"></el-input>
    <span class="error-message"><strong>{{$validator.errors.first(name, validateScope)}}</strong></span>
  </div>
</template>

<script lang="js">
import FormatUtil from '../../../utils/format'

export default {
  name: 'FieldInputCmp',
  components: {},
  props: {
    value: null,
    name: String,
    placeholder: null,
    validate: null,
    validateLabel: String,
    validateScope: null,
    disabled: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    type: {type: String, default: 'text'}
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data () {
    return {
      internalValue: FormatUtil.num2FracStr(this.value)
    }
  },
  watch: {
    value (newValue) {
      this.internalValue = newValue
    },
    internalValue (newValue) {
      this.$emit('input', newValue)
    }
  }
}

</script>
<style scoped>
  .field-input {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field/input.vue